function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 19h13.414l-4.153-4.153C13.164 13.448 13.939 13 15.5 13c.885 0 1.793.316 2.663.852.314.193.599.4.848.606.144.12.24.208.282.25L21 16.413V14c0-3.821-4.113-7-8-7-2.11 0-3.475.455-4.847 1.552-.362.29-.658.557-1.15 1.037L3 5.586V19zm2-2v-6.586l2 2 .707-.707c.917-.916 1.266-1.25 1.695-1.593C10.412 9.307 11.332 9 13 9c1.922 0 3.953 1.076 5.09 2.562-.83-.358-1.697-.562-2.59-.562-2.617 0-3.954 1.03-5.368 3.504l-.38.663L11.587 17H5z",
  fill: "#000"
});

function SvgArrowBoldUndo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgArrowBoldUndo;